import { useState } from 'react';
import { Button, Form, Row, Col } from 'react-bootstrap';
import { Delete } from '@mui/icons-material';
import { Floppy2Fill } from 'react-bootstrap-icons';
import { Device } from '../../shared/generated';

interface Props {
    device: Device;
    onCancel: () => void;
    onSave: (updated: Partial<Device>) => void;
    onDelete: () => void;
}

export default function MobileDeviceDetailsForm({ device, onCancel, onSave, onDelete }: Props) {
    const [comment, setComment] = useState(device.Comment || '');
    const [balance, setBalance] = useState<number>(device.Balance);
    const [cost, setCost] = useState<number>(device.Cost);
    const [charge, setCharge] = useState<number>(device.Charge);
    const [blocked, setBlocked] = useState(!!device.Blocked);
    const [banned, setBanned] = useState(!!device.Banned);
    const [imei, setImei] = useState(device.Imei || '');
    const [storagePeriod, setStoragePeriod] = useState<number>(device.StoragePeriod);

    const save = () => {
        const upd: Partial<Device> = {};
        if (comment !== device.Comment) upd.Comment = comment;
        if (balance !== device.Balance) upd.Balance = balance;
        if (cost !== device.Cost) upd.Cost = cost;
        if (charge !== device.Charge) upd.Charge = charge;
        if (blocked !== device.Blocked) upd.Blocked = blocked;
        if (banned !== device.Banned) upd.Banned = banned;
        if (imei !== device.Imei) upd.Imei = imei;
        onSave(upd);
    };

    return (
        <Form>
            <Row className="mb-2">
                <Col>
                    <Form.Group>
                        <Form.Label>Модель</Form.Label>
                        <div>{device.DeviceModelName}</div>
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>С/н</Form.Label>
                        <div>{device.Serial}</div>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-2">
                <Col>
                    <Form.Group>
                        <Form.Label>Баланс</Form.Label>
                        <Form.Control type="number" value={balance} onChange={(e) => setBalance(e.target.value === '' ? 0 : Number(e.target.value))} />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>Ц.Д.</Form.Label>
                        <Form.Control type="number" value={cost} onChange={(e) => setCost(e.target.value === '' ? 0 : Number(e.target.value))} />
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-2">
                <Col>
                    <Form.Group>
                        <Form.Label>Аб. плата</Form.Label>
                        <Form.Control type="number" value={charge} onChange={(e) => setCharge(e.target.value === '' ? 0 : Number(e.target.value))} />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>IMEI</Form.Label>
                        <Form.Control type="text" value={imei} onChange={(e) => setImei(e.target.value.slice(0, 15))} />
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-2">
                <Col>
                    <Form.Check type="checkbox" id="DeviceIsBlocked" label="Заблок." checked={blocked} onChange={(e) => setBlocked(e.target.checked)} />
                </Col>
                <Col>
                    <Form.Check type="checkbox" id="DeviceIsBanned" label="Откл." checked={banned} onChange={(e) => setBanned(e.target.checked)} />
                </Col>
            </Row>
            <Row className="mb-2">
                <Col>
                    <Form.Group>
                        <Form.Label>Период хранения</Form.Label>
                        <Form.Control type="text" value={storagePeriod} onChange={(e) => setStoragePeriod(e.target.value === '' ? 0 : Number(e.target.value))} />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>Тест</Form.Label>
                        <Form.Control type="text" disabled value={device.TestMode ? "Да" : "Нет"} />
                    </Form.Group>
                </Col>
            </Row>
            <Form.Group className="mb-2">
                <Form.Label>Комментарий</Form.Label>
                <Form.Control as="textarea" rows={2} value={comment} onChange={(e) => setComment(e.target.value)} />
            </Form.Group>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '.5rem', marginTop: '.5rem' }}>
                <Button variant="custom" onClick={onDelete}>
                    <Delete />
                    Удалить
                </Button>
                <div style={{ display: 'flex', gap: '.5rem' }}>
                    <Button variant="secondary" onClick={onCancel}>Отмена</Button>
                    <Button variant="custom" onClick={save}>
                        <Floppy2Fill className="marginRight" />
                        Сохранить
                    </Button>
                </div>
            </div>
        </Form>
    );
}